import React from 'react';
import { Route, withRouter } from 'react-router-dom';

const PublicRoute = ({ component: Component, restricted, ...rest }) => (
  <Route {...rest} render={(props) => <Component {...props} />} />
);

export default withRouter(PublicRoute);
